import { useQuery } from '@tanstack/react-query'
import { getReviewDetail } from '../services'

/**
 * Custom hook để lấy chi tiết review theo ID
 * @param reviewId - ID của review cần lấy
 * @param enabled - Điều kiện để kích hoạt query (mặc định là true khi có reviewId)
 * @returns Object chứa reviewDetail, isLoading, error
 */
export function useReviewDetail(reviewId: number | undefined, enabled: boolean = true) {
  const {
    data: reviewDetail,
    isLoading,
    error,
    refetch,
  } = useQuery({
    queryKey: ['REVIEW_DETAIL', { reviewId }],
    queryFn: () => getReviewDetail(reviewId!),
    enabled: enabled && !!reviewId,
    staleTime: 60 * 1000, // Cache trong 60 giây
  })

  return { reviewDetail, isLoading, error, refetch }
}
